














































































































































































































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';

import { ErrorHandler } from '@/models/errors';
import { omit } from 'lodash';

import {
  IQuotePaymentTermItem,
  IQuotePaymentTermItemData,
  IQuotePaymentTermTemplate,
  QuotePaymentTermItem,
  QuotePaymentTermTemplate
} from '@/models';

import { ErrorManager } from '@/models/error';
import QuillPDFEditor from '../common/QuillPDFEditor.vue';
import QuoteTemplateNoteDropDownItem from './section/QuoteTemplateNoteDropDownItem.vue';
import QuoteTemplateNoteTooltipIcon from './templates/common/QuoteTemplateNoteTooltipIcon.vue';

const baseMixins = mixins(BindsAttrs, Validatable);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuotesPaymentTermItemsSection',

    components: {
      QuillPDFEditor,
      QuoteTemplateNoteDropDownItem,
      QuoteTemplateNoteTooltipIcon
    },

    props: {
      editable: Boolean,

      language: {
        type: String
      },

      errors: {
        type: Object as PropType<ErrorHandler>
      }
    },

    data: () => ({
      selectedPaymentTerm: null as null | number,
      loading: false,
      errorMessage: ''
    }),

    watch: {
      internalValue: {
        handler() {
          this.validate();
        },
        deep: true
      }
    },

    computed: {
      ...mapGetters({
        getQuotePaymentTermTemplateById:
          'quoteTemplate/getQuotePaymentTermTemplateById',
        activePaymentTermTemplates:
          'quoteTemplate/getActiveQuotePaymentTermTemplates'
      }),

      requiredRule() {
        return (field: string) => [
          (v: string) => !!v || `${field} is required`
        ];
      }
    },

    mounted() {
      this.fetchPaymentTermItems();
    },

    beforeCreate() {
      // v-radio-group needs to emit a different event
      // https://github.com/vuetifyjs/vuetify/issues/4752
      this.$_modelEvent =
        (this.$options.model && this.$options.model.event) || 'input';
    },

    methods: {
      ...mapActions({
        fetchQuotePaymentTermTemplates:
          'quoteTemplate/fetchQuotePaymentTermTemplates'
      }),

      clearAllErrors() {
        this.errorMessage = '';
      },

      fetchPaymentTermItems() {
        this.clearAllErrors();
        this.loading = true;
        return this.fetchQuotePaymentTermTemplates()
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      removePaymentTermItem(item: IQuotePaymentTermTemplate, index?: number) {
        this.clearAllErrors();

        const itemIndex = index ?? this.internalValue.indexOf(item);
        this.internalValue.splice(itemIndex, 1);
      },

      addPaymentTermItem() {
        this.clearAllErrors();

        this.internalValue.push(new QuotePaymentTermTemplate());
      },

      setPaymentTerm(value: IQuotePaymentTermTemplate, index: number) {
        this.clearAllErrors();

        const paymentTermItemData: IQuotePaymentTermItemData = {
          template: value['id']!,
          ...omit(value, ['id'])
        };
        //https://vuejs.org/v2/guide/reactivity.html#For-Arrays.
        this.$set(
          this.internalValue,
          index,
          new QuotePaymentTermItem(paymentTermItemData)
        );

        this.selectedPaymentTerm = null;
      },

      clearSelectedValue(index: number) {
        this.internalValue[index].id = null;
        this.internalValue[index].template = null;
        this.internalValue[index].title = '';
        this.internalValue[index].description = '';
      },

      textChanged(index: number) {
        // clear template ID whenever text changes
        // to prevent a translation lookup for custom text
        this.internalValue[index].template = null;
      },

      termItemTemplateNote(termItem: IQuotePaymentTermItem) {
        const template = this.getQuotePaymentTermTemplateById(
          termItem.template
        );
        let note = '';
        if (template) {
          note = template.note;
        }
        return note;
      }
    }
  });
